<template>


    <div class="modal-backdrop"></div>

    <div class="modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-body" style="text-align: center;">
                <div class="spinner-border" style="width: 6rem; height: 6rem; margin-top:20px; margin-bottom:20px;" role="status">
                </div>
                <h5 style="margin-top:20px;" v-html="titulo"></h5>
            </div>
        </div>
    </div>
    </div>


</template>

<script>

export default {
  name: 'PantalladeCarga',
  props: {

    titulo : String

  }

}
</script>

<style scoped>

    .modal {

        display: block;
        opacity: 1;


    }

    .modal-dialog {
        
        margin: 0 auto;
        max-width: 250px;

    }
</style>